import type { ChangeEvent } from "react";
import { inputStyle } from "./FormField";

// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): el buscador de la barra de
// filtros (BenefitsScreen.tsx, RewardsScreen.tsx) era el mismo marcado
// palabra por palabra, solo con placeholders distintos. Extracción sin
// cambio de comportamiento ni de valores visuales.
export function SearchField({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
}) {
  return (
    <div style={{ flex: 1, minWidth: 230, maxWidth: 340 }}>
      <input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{ ...inputStyle, padding: "11px 13px" }}
      />
    </div>
  );
}
